// @flow @jsx h

import { h, Component } from 'preact'
import style from './index.css'

import type { Viewport } from '../../types'

type Props = {
  viewport: Viewport,
  title: string,
  lead: string
}

type State = {}

export class IntroCard extends Component<Props, State> {
  render () {
    const { viewport, title, lead } = this.props
    const wrapperInlineStyle = {}

    if (viewport && viewport.height > -1) {
      wrapperInlineStyle.marginTop = `${0.4 * viewport.height - 10}px`
    }

    return (
      <div className={style.introCard}>
        <div
          className={style.introCard__wrapper}
          style={wrapperInlineStyle}>
          <h1>{title}</h1>
          <p>{lead}</p>
        </div>
      </div>
    )
  }
}
